import { BrowserRouter, Switch, Route, HashRouter } from 'react-router-dom';
import React, { Component } from 'react';
import { connect } from "react-redux";
import NotFound from 'VENDOR/CommonResources/NotFound/NotFound';
import VendorDasboard from 'VENDOR/Components/vendorDashboard/VendorDashboard';
import VendorQuotation from 'VENDOR/Components/VendorQuotation/VendorQuotation';
import VendorPO from 'VENDOR/Components/vendorPO/VendorPO';
import config from 'config';
import { getAssignedIIDArray, getAssignedInstituteObject } from 'VENDOR/Actions/RoutingActions';
import vendorApiCall from 'vendorApiCall';
import VendorDelivery from 'VENDOR/Components/VendorDelivery/VendorDelivery';
export class RoutesSetup extends Component {
    constructor(props) {
        super(props)
       
    }
   
    componentDidMount = () => {
        if(this.props.iidArray == undefined  || Object.keys(this.props.iidArray).length <= 0 )
        {
            this.GetInstructorAssignedInstituteList();
        }
    }
    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.iidArray) != JSON.stringify(prevProps.iidArray)) {
            this.setState({
                iidArray:this.props.iidArray,
            },()=>{
                this.GetInstructorAssignedInstituteList();
            })
        }
        

    }

    GetInstructorAssignedInstituteList = async () => {
        let requestData = {
            vendorEmail: config.instructorInfo.data.EmailId   
        };

        let jsonResponse = await vendorApiCall.makeApiCall(
            'inventory_getVendorsInstitutes',
            requestData,
            "/vendor/api/vendor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstructorAssignedInstituteList();
            }, 1000);
        } else {
            if (jsonResponse.success) { 
                
                console.log(jsonResponse.APIResult);
                this.props.dispatchAssignedIIDArray(jsonResponse.APIResult.iidArray);
                this.props.dispatchAssignedIIDObject(jsonResponse.APIResult.data);
            } 
        }
    }

   

    render() {
        return (
            <>
                <HashRouter>
                    <Switch>
                      
                        {/* <Route path="*" component={NotFound} /> */}
                        <Route path="/quotations" component={VendorQuotation} />
                        <Route path="/purchase-order" component={VendorPO} />
                        <Route path="/delivery-schedule" component={VendorDelivery} />
                        <Route path="/" component={VendorDasboard} />
                       
                    </Switch>
                </HashRouter>
            </>
        )
    }
}

const mapStateToProps = (store) => ({
    iidArray: store.RouteMenuReducer.assignedIIDArray,
    iidDetails: store.RouteMenuReducer.assignedIIDDetails,
  });
  

  const mapDispatchToProps = (dispatch) => {
    return{
    
        dispatchAssignedIIDObject:(apiResult) => dispatch(getAssignedInstituteObject(apiResult)),
        dispatchAssignedIIDArray:(apiResult) => dispatch(getAssignedIIDArray(apiResult)),
    };
}
export default  connect(mapStateToProps, mapDispatchToProps)(RoutesSetup);
